import { useQuery } from "react-query";
import { getAccount } from "../services";

export const useAccount = (accountNumber?: string) => {
  return useQuery(["accounts", accountNumber!], getAccount, {
    enabled: !!accountNumber,
  });
};
